import type { StaticRouteNavigateProps } from "./static-route-navigate.type";

import { Navigate } from "react-router";

import { useStaticRouteLink } from "../static-route-link";

export const StaticRouteNavigate = ({
  route,
  customContext,
  search,
  replace,
  state,
}: StaticRouteNavigateProps) => {
  const options = { customContext, search };
  const link = useStaticRouteLink(route, options);

  if (!link) return null;

  return <Navigate to={link} replace={replace} state={state} />;
};
